import { Injectable } from "@angular/core";
import { DocMetadataHandler } from "./add-doc-metadata.interface";
import { DocMetadata, DocMetadataDto, DocMetadataGroup, DocMetadataInfo } from "../model/doc-metadata";
import { ClaimDocMetadata } from "src/app/claims-view/model/claims-view.model";




@Injectable()
export class ClaimDocMetadataHandler extends DocMetadataHandler {

    claimDocMetadata!: ClaimDocMetadata[];
    initiMetadataSelections: {[group: string]: DocMetadata[] | DocMetadata | null} = {};

    enableSaveMetadataChanges(): boolean {

        if (this.groups == null || this.groups.length == 0) {
            return false;
        }
        let requiredDocMetadata: DocMetadataGroup[] = this.groups.filter((group) => group.isRequired);

        if (requiredDocMetadata.length == 0) {
            return true;
        }
        for (let data of requiredDocMetadata) {

            let selectedData = this.selections[data.groupName];
            if (selectedData == null) {
                return false;
            }
            if (Array.isArray(selectedData) && selectedData.length == 0) {
                return false;
            }
        }
        return true;
    }

    updateClaimMetadata(newMetadata: { [key: string]: string[] }): ClaimDocMetadata[] {

        let claimDocMetadata: ClaimDocMetadata[] = [];
        if (Object.keys(newMetadata)?.length) {

            let allMetadata = Object.keys(newMetadata);
            for (let metadata of allMetadata) {

                let group: DocMetadataGroup | undefined = this.groups.find((group) => group.groupName == metadata);
                if (group) {

                    let fieldLabel = group.groupLabel;
                    let fieldName = group.groupName;
                    let values = newMetadata[metadata];
                    let groupMetadata = this.docMetadataByGroup[group.groupName];
                    
                    let fieldValues: string[] = [];
                    for (let value of values) {

                        let foundMetadata = groupMetadata.find((metadata) => metadata.fieldValue == value);
                        if (foundMetadata) {
                            fieldValues.push(foundMetadata.fieldLabel);
                        }
                    }
                    claimDocMetadata.push({
                        fieldLabel: fieldLabel,
                        fieldName: fieldName,
                        fieldValues: fieldValues
                    })

                }
                
            }
        }

        return claimDocMetadata;

    }
    private saveInitMetadata() {

        this.initiMetadataSelections = structuredClone(this.selections);

    }
    public discardMetadataChanges() {

        this.selections = structuredClone(this.initiMetadataSelections);
    }


    override extractDocMetadataInfo(data: DocMetadataDto[]): DocMetadataInfo {

            let extractedMetadata: DocMetadataInfo = super.extractDocMetadataInfo(data);

            this.docMetadataByGroup = extractedMetadata.docMetadataByGroup;
            this.groups = extractedMetadata.groups;

            this.setInitValuesBasedOnClaimMetadata(this.claimDocMetadata);
            this.saveInitMetadata();
            
            return extractedMetadata;
    }

    private setInitValuesBasedOnClaimMetadata(claimDocMetadata: ClaimDocMetadata[]) {

        if (claimDocMetadata == null || claimDocMetadata.length == 0) {
            return;
        }

        for (let elem of claimDocMetadata) {

            let groupMetadata: DocMetadata[] = this.docMetadataByGroup[elem.fieldName];
            if (groupMetadata) {

                for (let value of elem.fieldValues) {

                    let dataToPreselect = groupMetadata.find((metadata) => metadata.fieldLabel == value);

                    if (dataToPreselect == undefined) {
                        continue;
                    }
                    let metadataGroup = this.groups.find((group) => group.groupName == elem.fieldName);
                    if (metadataGroup?.isMultiValued) {

                        if (this.selections[metadataGroup.groupName] == null) {

                            this.selections[metadataGroup.groupName] = [];
                        }
                        let groupSelections = this.selections[metadataGroup.groupName] as DocMetadata[];
                        groupSelections.push(dataToPreselect);
                    } else {
                        this.selections[elem.fieldName] = dataToPreselect;
                    }
                }
            }
        }


    }
}